/**
 * Query model for instrument approach types
 */
export enum ApproachType {
  ILS = 'ILS',
  RNAV = 'RNAV',
  VOR = 'VOR'
}
